(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56567],{

/***/ 56567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PersonBlog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/Paginator/index.jsx + 1 modules
var Paginator = __webpack_require__(65300);
// EXTERNAL MODULE: ./components/BlogCommon/ArticlesList/index.jsx + 3 modules
var ArticlesList = __webpack_require__(63111);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/Blog/utils/usePersonBlog.js



/* harmony default export */ function usePersonBlog(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _description = param.description, description = _description === void 0 ? "" : _description, currentPage = param.currentPage, articlesNumberPerPage = param.articlesNumberPerPage, items = param.items, total = param.total;
    var articlesList = items === null || items === void 0 ? void 0 : items.map(function(article) {
        var _ref = (0,helper/* getDocumentFields */.OA)(article, [
            "introduction",
            "previewImageUrl",
            "publishedAt",
            "slug",
            "title",
            "tagsList", 
        ]), image = _ref.previewImageUrl, tagsList = _ref.tagsList, fields = (0,_object_without_properties/* default */.Z)(_ref, [
            "previewImageUrl",
            "tagsList"
        ]);
        var tagsListCollection = {
            items: tagsList.map(function(tag) {
                return (0,helper/* getDocumentFields */.OA)(tag, [
                    "slug"
                ]);
            })
        };
        var previewImageUrl = {
            url: (0,helper/* getFileUrl */.qm)(image)
        };
        return (0,_object_spread/* default */.Z)({
            previewImageUrl: previewImageUrl,
            tagsListCollection: tagsListCollection
        }, fields);
    });
    var pagesCounter = Math.ceil(total / articlesNumberPerPage);
    return {
        title: title,
        description: description,
        articlesList: articlesList,
        currentPage: currentPage,
        pagesCounter: pagesCounter
    };
};

// EXTERNAL MODULE: ./UI/sections/Blog/PersonBlog/styles.module.scss
var styles_module = __webpack_require__(14413);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/Blog/PersonBlog/index.jsx








var PersonPageBlog = function(props) {
    var ref = usePersonBlog(props), title = ref.title, description = ref.description, articlesList = ref.articlesList, currentPage = ref.currentPage, pagesCounter = ref.pagesCounter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (styles_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                description: description,
                titleStyle: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList/* default */.Z, {
                        articles: articlesList,
                        currentPage: currentPage
                    }),
                    !!pagesCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginator/* default */.Z, {
                        pagesCounter: pagesCounter,
                        currentPage: currentPage,
                        pageSlug: constants/* ROUTES.person.slug */.y2.person.slug
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PersonBlog = (PersonPageBlog);


/***/ }),

/***/ 14413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__UeWlc","titleStyle":"styles_titleStyle__P0Sot","container":"styles_container__54PAj","swiperWrapper":"styles_swiperWrapper__J00if"};

/***/ })

}]);